export class EventPageAdding {
    facebookPageUrlOrName: string;
    displayTitle?: string;
    tags?: string;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.account/event.add.page.ts